import { render, staticRenderFns } from "./ServiceComments.vue?vue&type=template&id=43234063&scoped=true"
import script from "./ServiceComments.vue?vue&type=script&lang=js"
export * from "./ServiceComments.vue?vue&type=script&lang=js"
import style0 from "./ServiceComments.vue?vue&type=style&index=0&id=43234063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43234063",
  null
  
)

export default component.exports